// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.paymentterms.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/paymentterms/paymentterm/paymentterm.tpl.html',
            controller: 'PaymentTermController as vm'
        }},
        resolve: {
            paymentterm: function() { return {}; },
            languages: languagesResolver,
            isNewPaymentTerm: function() {return true;}
        }
    });

    $stateProvider.state('base.paymentterms.paymentterm', {
        url:'/{paymenttermId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/paymentterms/paymentterm/paymentterm.tpl.html',
            controller: 'PaymentTermController as vm'
        }},
        resolve: {
            paymentterm: paymenttermResolver,
            languages: languagesResolver,
            isNewPaymentTerm: function() {return false;}
        }
    });

}

// @ngInject
function paymenttermResolver($stateParams, PaymentTermsApiService) {
    return PaymentTermsApiService.getPaymentTerm($stateParams.paymenttermId);
}

// @ngInject
function languagesResolver($stateParams, PaymentTermsApiService) {
    return PaymentTermsApiService.getLanguages();
}

// @ngInject
function PaymentTermController($state, paymentterm, loadSpinnerService, PaymentTermsApiService, ToasterService, confirmationDialogService, $translate, isNewPaymentTerm, languages) {
    var vm = this;

    var paymenttermCopy = {};

    vm.paymentterm = paymentterm;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.savePaymentTerm = savePaymentTerm;
    vm.deletePaymentTerm = deletePaymentTerm;

    vm.isNewPaymentTerm = isNewPaymentTerm;
    vm.isEditing = vm.isNewPaymentTerm;

    vm.isPaymentTermCodeValid = isPaymentTermCodeValid;
    vm.isAllInformationValid = isAllInformationValid;
    vm.languages = languages;

    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewPaymentTerm) {
            vm.paymentterm = {};
        }

        appendLocalizations(vm.paymentterm, vm.languages);

    }

    function appendLocalizations(obj, languages) {
        if (!obj.localizations) {
            obj.localizations = [];
        }
        _.forEach(languages, function(language) {
            if (_.filter(obj.localizations, { language: { id: language.id}}).length === 0) {
                obj.localizations.push({ language: language });
            }
        });
    }

    function enableEditing() {
        paymenttermCopy = angular.copy(vm.paymentterm);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.paymentterm = paymenttermCopy;
        vm.isEditing = false;
    }

    function savePaymentTerm() {
        if (vm.isNewPaymentTerm) {
            saveNewPaymentTerm();
        } else {
            updatePaymentTerm();
        }
    }

    function saveNewPaymentTerm() {
        loadSpinnerService.start('mainSpinner');
        PaymentTermsApiService.createPaymentTerm(vm.paymentterm).then(function(response) {
            vm.paymentterm = response;
            prepareData();
            vm.isNewPaymentTerm = false;
            vm.isEditing = false;
            $state.go('base.paymentterms.paymentterm', {paymenttermId: vm.paymentterm.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updatePaymentTerm() {
        loadSpinnerService.start('mainSpinner');

        PaymentTermsApiService.updatePaymentTerm(vm.paymentterm).then(function(response) {
            vm.paymentterm = response;
            prepareData();
            vm.isNewPaymentTerm = false;
            vm.isEditing = false;
            $state.go('base.paymentterms.paymentterm', {paymenttermId: vm.paymentterm.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deletePaymentTerm() {
        confirmationDialogService
            .showDialog($translate.instant('paymentterm.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    PaymentTermsApiService.deletePaymentTerm(vm.paymentterm.id).then(function(response) {
                        vm.paymentterm = response;
                        prepareData();
                        vm.isNewPaymentTerm = false;
                        vm.isEditing = false;
                        $state.go('base.paymentterms');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(paymentterm) {
        paymentterm.showEditForm = !paymentterm.showEditForm;
    }

    function prepareData() {
        if (vm.paymentterm === undefined) {
            return;
        }

        vm.paymenttermCopy = angular.copy(vm.paymentterm);
    }

    function isAllInformationValid() {
        return isPaymentTermCodeValid();
    }

    function isPaymentTermCodeValid() {
        if (!vm.paymentterm.code) { return false; }
        if (vm.paymentterm.code.length > 20) { return false; }

        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('paymentterms.paymentterm', [])
    .config(stateConfig)
    .controller('PaymentTermController', PaymentTermController);
